
import { defineComponent } from 'vue';
import { useController } from '@/domain/services/Composer';
import { viewCartController } from '@/modules/ecommerce/components/ViewCart.controller';

export default defineComponent({
	props: {
		label: {
			type: String,
			required: true,
		},
		cartRoute: {
			type: String,
			required: true,
		},
		title: {
			type: String,
			required: true,
		},
	},

	setup: useController(viewCartController, 'viewCartDetailsController'),
});
